module.exports = __webpack_public_path__ + "img/TOCTemp4.5e829acf.png";